import React from "react";
import format from "date-fns/format";

const WidgetName = props => {
  const timestamp = props.updated ?
    format(new Date(props.updated), "h:mm a '-' M/d/y") :
    "";

  const title = props.widget.title;
  const processTitle = title?.replace(/#slider/i, '').trim()

  return (
    <div className="widget-title">
      <div className={
        "grid-row" +
        (props.widget.showTitle ? "" : " no-title")
      }>
        {props.widget.showTitle && (<div className="title">{processTitle}</div>)}
        {props.widget.showTimestamp && timestamp && (
          <div className="date-stamp">
            <span>Last updated: {timestamp}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default WidgetName;
